import { Module } from 'vuex';
import { ApplicationFormNumberSettingState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: ApplicationFormNumberSettingState = {
    applicationFormNumberSetting: undefined,
    prefixPreview: undefined,
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    preview: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const applicationFormNumber: Module<ApplicationFormNumberSettingState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
